<template>
  <div>
    <!-- 面包屑 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>库存管理</el-breadcrumb-item>
      <el-breadcrumb-item>内部发放-接收列表</el-breadcrumb-item>
    </el-breadcrumb>
    <el-date-picker
      v-model="purchaseRequest.selectDate"
      type="daterange"
      range-separator="至"
      start-placeholder="开始日期"
      end-placeholder="结束日期"
      value-format="yyyy-MM-dd"
      size="mini"
      @change="loadSendList"
    >
    </el-date-picker>
    <el-input v-model="purchaseRequest.name" placeholder="请输入内容" size="mini" style="width: 200px;"></el-input>
    <el-button size="mini" @click="loadSendList">查询</el-button>
      <el-table height="550px" :data="receptionProductList" fit border stripe="stripe"
                :header-cell-style="{background:'#eff3f8', color:'#333'}">
        <el-table-column
          prop="purchaseDate"
          label="发放日期"
          align="center"
          width="100">
        </el-table-column>
        <el-table-column
          prop="productName"
          label="产品名称"
          align="center">
        </el-table-column>
        <el-table-column
          prop="sendNum"
          label="发放数量"
          align="center">
        </el-table-column>
        <el-table-column
          prop="purchaseMoney"
          label="产品费用"
          align="center">
        </el-table-column>
        <el-table-column
          prop="senderName"
          label="发放人"
          align="center">
        </el-table-column>
        <el-table-column
          prop="outOrgName"
          label="发放机构"
          align="center">
        </el-table-column>
        <el-table-column
          prop="purchaseNo"
          label="发放单号"
          align="center"
          width="210">
        </el-table-column>
      </el-table>
      <div style="margin-top: 3px;">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageTotal">
        </el-pagination>
      </div>
  </div>
</template>

<script>
export default {
  data(){
    return{
      currentOrgId:'',
      orgLevel:'',
      authorities:'',
      userId:'',
      receptionProductList:[],

      currentPage: 1,
      pageSize:20,
      pageTotal:0,
      purchaseRequest:{
        selectDate:'',
        orgId:'',
        pageNum:'',
        pageSize:'',
        startDate:'',
        endDate:'',
        name:'',
        state:'',
        outOrgId:'',
        inOrgId:''
      },
    }
  },
  methods:{
    handleSizeChange(val) {
      this.pageSize = val;
      this.loadSendList();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.loadSendList();
    },

    //加载发送列表
    async loadSendList(){
      this.totalMoney = '';
      this.totalNum = '';
      this.purchaseRequest.startDate = '';
      this.purchaseRequest.endDate = '';
      if (this.purchaseRequest.selectDate !== null){
        this.purchaseRequest.startDate = this.purchaseRequest.selectDate[0];
        this.purchaseRequest.endDate = this.purchaseRequest.selectDate[1];
      }
      this.purchaseRequest.pageNum = this.currentPage;
      this.purchaseRequest.pageSize = this.pageSize;
      this.purchaseRequest.inOrgId = this.currentOrgId;
      const {data:res} = await this.$http.post(`/receive/query`, this.purchaseRequest);
      if (res.code === 200){
        this.receptionProductList = res.data.list;
        this.pageTotal = res.data.total;
      }
    },
  },
  created() {
    this.currentOrgId = window.sessionStorage.getItem('currentOrgId');
    this.userId = window.sessionStorage.getItem("userId");
    this.orgLevel = window.sessionStorage.getItem("orgLevel");
    this.authorities = window.sessionStorage.getItem('authorities');
    this.loadSendList();
  }
}
</script>

<style lang="less" scoped>
.container{
  height: 90vh;
  overflow-y: hidden;
}
.between{
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  height: 90vh;
}

.left_con{
  display: flex;
  justify-content: start;
  height: 100%;
  overflow-y: auto;
  //flex: 1;
  width: auto;
  //border: 1px solid;
  margin: 10px 0;
  //width: 100px;
}
.left_inner_con{
  width: 300px;
  height: 90vh;
  overflow-y: auto;
  margin-right: 10px;
  //background-color: #F2F6FC;
}
.el-table, .el-table__cell {
  /deep/ th {
    padding: 2px ;
    text-align: center !important;
  }
  /deep/ td {
    padding: 2px ;
  }
}
/deep/ .el-drawer__header{
  z-index: 1;
  position: relative;
  color: #ffffff !important;
  .el-dialog__title{
    color: #ffffff;
  }
  .el-dialog__close{
    color: #ffffff !important;
  }
}
.dialog-footer{
  display: flex;
  margin: 10px 0;
  justify-content: center;
  width: 100%;
}
/deep/ .el-drawer__header{
  z-index: 1;
  position: relative;
  color: #ffffff !important;
  .el-dialog__title{
    color: #ffffff;
  }
  .el-dialog__close{
    color: #ffffff !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Receive.vue